import { Label } from '@primer/react';
import { BreadcrumbVariants } from '@primer/react-brand';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  Label,
  BreadcrumbVariants,
  PropTableValues,
  React
};